import { Product } from "../appData/productData"
import { useAppState } from "../context/appStateContext"
import { useExpiration } from "../context/expirationContext"
import { usePurchase } from "../context/purchaseContext"
import useStrings from "../localization/useStrings"
import useQueryParams from "./useQueryParams"

export interface ExpirationPaywallItem {
  title: string
  shortTitle: string
  product: Product
  popular: boolean
  showPerMonth: boolean
  isUltimate: boolean
}
export default function useExpirationPricingItems() {
  const { state } = usePurchase()
  const ultimatePlan = useAppState().state.productData?.ultimate
  const strings = useStrings().freeTrialPaywall.comparePlans

  const isUltimate = useExpiration().state.isUltimate
  const plan = isUltimate ? ultimatePlan! : state.selectedPlan

  const showUltimateInExpiration = useQueryParams().showUltimateInExpiration

  let items: ExpirationPaywallItem[] = [
    {
      title: strings.monthly,
      shortTitle: strings.monthly,
      product: plan.monthlyProduct,
      popular: false,
      showPerMonth: true,
      isUltimate: false,
    },
    {
      title: strings.yearly,
      shortTitle: strings.yearly,
      product: plan.yearlyProduct,
      popular: true,
      showPerMonth: true,
      isUltimate: false,
    },
  ]

  if (showUltimateInExpiration && !isUltimate) {
    items.push({
      title: strings.ultimateYearly,
      shortTitle: "Ult. Yearly",
      product: ultimatePlan!.yearlyProduct,
      popular: false,
      showPerMonth: true,
      isUltimate: true,
    })
  } else {
    items.push({
      title: strings.threeMonths,
      shortTitle: strings.threeMonths,
      product: plan.threeMonthsProduct,
      popular: false,
      showPerMonth: false,
      isUltimate: false,
    })
  }

  return items
}
